export function isNativeShareSupported(url?: string): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  if (!window.isSecureContext || typeof navigator.share !== 'function') {
    return false;
  }

  if (url && typeof navigator.canShare === 'function') {
    try {
      return navigator.canShare({ url });
    } catch {
      return false;
    }
  }

  return true;
}

export function buildCaregiverProfileLink(profileLinkPath: string): string {
  const routePrefix = '/profile';
  const profilePath = `${routePrefix}/${profileLinkPath}`;
  return typeof window === 'undefined' ? profilePath : `${window.location.origin}${profilePath}`;
}

// Extract just the path portion for display (e.g., "/profile/john-d-12345")
export function getDisplayPathFromUrl(url: string): string {
  try {
    return new URL(url).pathname;
  } catch {
    return url;
  }
}
